<aside
    class="flex h-screen flex-col border-r border-transparent bg-gradient-to-b from-[#0284c7] via-[#0f6ebd] to-[#0d9488]"
    [class.w-64]="!isCollapsed()"
    [class.w-[4.5rem]]="isCollapsed()"
>
    <!-- Header with Logo -->
    <div class="flex h-18 shrink-0 items-center gap-2 px-4">
        <!-- Company Logo -->
        <img
            [routerLink]="['/admin']"
            [src]="currentLogoSrc()"
            [alt]="logoAlt()"
            class="cursor-pointer object-contain brightness-0 drop-shadow-md invert transition-all hover:scale-[1.02]"
            [class.w-52]="!isCollapsed()"
            [class.w-12]="isCollapsed()"
        />
    </div>

    <!-- Navigation Menu -->
    <nav class="custom-scrollbar flex-1 overflow-x-hidden overflow-y-auto p-3">
        @for (group of navigationGroups(); track group.label) {
            <div class="mb-6">
                <!-- Group Label -->
                @if (showLabel() && group.label) {
                    <div
                        class="mb-2 px-3 text-xs font-semibold tracking-wider text-white/70 uppercase"
                    >
                        {{ group.label }}
                    </div>
                }

                <!-- Group Items -->
                <ul class="space-y-1">
                    @for (item of group.items; track item.label) {
                        <li>
                            <a
                                [routerLink]="item.routerLink"
                                [routerLinkActiveOptions]="{
                                    exact:
                                        item.exact ??
                                        item.routerLink === '/admin',
                                }"
                                routerLinkActive="nav-item-active"
                                class="nav-item group relative flex items-center rounded-xl px-3 py-2.5 text-[14px] font-medium text-white/80 transition-all duration-150 hover:bg-white/10 hover:text-white"
                                [class.justify-center]="!showLabel()"
                            >
                                @if (item.icon) {
                                    <ng-icon
                                        [name]="item.icon"
                                        class="h-[18px] w-[18px] shrink-0"
                                    />
                                }
                                @if (showLabel()) {
                                    <span class="ml-3 truncate">{{
                                        item.label
                                    }}</span>
                                }
                                @if (item.badge) {
                                    @if (showLabel()) {
                                        <span
                                            class="ml-auto rounded-full bg-white/20 px-2 py-0.5 text-xs font-semibold text-white"
                                        >
                                            {{ item.badge }}
                                        </span>
                                    } @else {
                                        <span
                                            class="absolute top-1.5 right-1.5 flex h-2 w-2 rounded-full bg-white"
                                        ></span>
                                    }
                                }
                            </a>
                        </li>
                    }
                </ul>
            </div>
        }
    </nav>
</aside>
